/* THRILA team order cart check (v3): minimum team quantity per garment and artwork present.
   Only ever blocks checkout when it has positively found a problem; if the cart cannot be read it does nothing. */
(function(){
  if(window.__thrilaTeamGuard3) return; window.__thrilaTeamGuard3=true;
  var MIN={10353221206314:6,10357338833194:6,10357338865962:6,10357338931498:6,10357338964266:6,10353307746602:1};
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/', problem=null, timer=null;
  function check(){
    return fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){return r.json()}).then(function(c){
      var by={};
      c.items.forEach(function(i){ if(!(i.product_id in MIN)) return; var g=by[i.product_id]=by[i.product_id]||{q:0,title:i.product_title,url:String(i.url||'').split('?')[0],art:true}; g.q+=i.quantity; if(!(i.properties&&i.properties.Artwork)) g.art=false; });
      for(var id in by){ var g=by[id];
        if(!g.art) return {msg:'"'+g.title+'" is missing its artwork. Please rebuild that order.',url:g.url};
        if(g.q<MIN[id]) return {msg:'"'+g.title+'" has a minimum order of '+MIN[id]+'. You have '+g.q+' in your cart.',url:g.url};
      }
      return null;
    }).catch(function(){return null});
  }
  function refresh(){ check().then(function(p){ problem=p; if(!p){ var m=document.getElementById('thrila-team-msg'); if(m) m.remove(); } }); }
  function soon(){ clearTimeout(timer); timer=setTimeout(refresh,400); }
  function show(b,p){
    var m=document.getElementById('thrila-team-msg');
    if(!m){m=document.createElement('div');m.id='thrila-team-msg';m.setAttribute('role','alert');m.style.cssText='border:1px solid #111;padding:14px;margin:12px 0;background:#fff;color:#111;font-size:14px';b.parentNode.insertBefore(m,b)}
    m.textContent=p.msg+' ';
    var a=document.createElement('a');a.href=p.url;a.textContent='Back to the team builder';a.style.textDecoration='underline';m.appendChild(a);
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[name="checkout"], .cart__checkout');
    if(!b){ if(e.target.closest&&e.target.closest('#CartPageForm, #CartDrawerForm')) soon(); return; }
    if(!problem) return;
    e.preventDefault(); e.stopImmediatePropagation(); show(b,problem); soon();
  },true);
  document.addEventListener('change',function(e){ if(e.target.closest&&e.target.closest('#CartPageForm, #CartDrawerForm')) soon(); });
  ['cart:updated','cart:build','cart:refresh','ajaxProduct:added'].forEach(function(n){ document.addEventListener(n,soon); });
  refresh();
})();
